import React from 'react';
import * as e from '../elements';

export default {
  name: 'Cover Video Left',
  description: 'Cover with explainer video',
  thumb: 'cover-video-left',
  tags: ['Cover', 'Video'],
  jsx: (
    <e.PBlock
      height="content"
      pad="hi"
    >
      <div className="row align-items-center">
        <div className="col-12 text-center col-md-6 my-3">
          <e.PVideo />
        </div>
        <div className="col-12 text-center col-md-6 text-md-left my-3">
          <e.PText
            color="primary"
            text="Our Product"
            size="header-h2"
            className="my-3"
          />
          <e.PText
            color="black-lo"
            text="Our one-liner slogan"
            size="subheader-md"
            className="my-3"
          />
          <e.PText
            color="black-md"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            size="text-md"
            className="my-3"
          />
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverVideoLeft.jsx